import isObject from "lodash/isObject";
import { snakeCase } from "snake-case";

export const hasKey = hash => {
  if (hash && Object.keys(hash).length > 0) {
    return true;
  }
  return false;
};

export const hasArray = list => {
  if (list && list.length > 0) {
    return true;
  }
  return false;
};

// objectのkeyをsnake_caseに変換
export const toSnakeCase = (
  obj // {[key: string]: any;}
) => {
  if (!isObject(obj)) {
    return obj;
  }
  const snakeCased = Object.keys(obj).reduce((acc, key) => {
    const newKey = snakeCase(key);
    acc[newKey] = obj[key];
    return acc;
  }, {});
  return snakeCased; // {[key: string]: any;}
};

// オブジェクト形式で渡されたパラメータをクエリパラメータの文字列に変換
// e.g. params: {start_date: `${yyyy-mm-dd}`; end_date: `${yyyy-mm-dd}`; enterprise_manning_vessel_ids: undefined | `${number}`[];}
//      => like `&start_date=${yyyy-mm-dd}&end_date=${yyyy-mm-dd}&enterprise_manning_vessel_ids=${number}&enterprise_manning_vessel_ids=${number}`
export const paramsToQueryString = (
  params // {[key:string]: string | number | undefined | string[] | number[];}
) => {
  const queryString = Object.keys(params).reduce((acc, key) => {
    const value = params[key];
    if (value === undefined) return acc;
    if (!Array.isArray(value)) return `${acc}&${key}=${value}`;
    const joined = value.map(v => `${key}=${v}`).join("&");
    return `${acc}&${joined}`;
  }, "");
  return queryString; // string
};
